import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'react-bootstrap';
import { CheckFormInput, CountryFormInput, TextAreaFormInput, TextFormInput } from '@/components';
import InquiryFormExtras from '@/components/InquiryFormExtras';
import useSiteInquiryForm from '@/hooks/useSiteInquiryForm';

const ContactForm = ({ sectionData }) => {
  const titleText = sectionData?.title?.trim() || 'Send us a message';
  const mapEmbedUrl =
    sectionData?.content?.map_embed_url ||
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3187.589666638337!2d25.741401576467906!3d35.0119308728299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x149b18d41eacf6d5%3A0x74b62fa2ec2df0bb!2sIerapetra!5e0!3m2!1sen!2sgr!4v1730900252001!5m2!1sen!2sgr';

  const bgColor = sectionData?.content?.background_color || sectionData?.background_color || 'light';
  const bgEffect = sectionData?.content?.background_effect || sectionData?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : bgColor === 'dark' ? 'bg-dark text-white' : 'bg-light';
  if (bgColor === 'primary' && bgEffect === 'gradient') bgClass = 'section-bg-primary-gradient';
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  const useDbBackground = !!(sectionData?.content?.background_color || sectionData?.background_color);

  const {
    control,
    onSubmit,
    status,
    error,
    confirmation,
    submitting,
    resetStatus,
    websiteField,
    setWebsiteField,
    turnstile,
    showTurnstileConfigWarning,
  } = useSiteInquiryForm({
    formType: 'contact',
    action: 'contact_inquiry',
    defaultValues: {
      name: '',
      email: '',
      mobileNo: '',
      country: '',
      message: '',
      newsletterOptIn: false
    },
    mapValues: (values) => ({
      contact_name: values.name,
      email: values.email,
      phone: values.mobileNo,
      country: values.country,
      message: values.message,
      newsletter_opt_in: Boolean(values.newsletterOptIn),
    }),
  });

  return (
    <section id="contact_form_customer" className={`contact-form-section pt-0 pt-lg-5 ${bgClass} ${hasDotsEffect ? 'overflow-hidden position-relative' : ''}`} {...(useDbBackground && { 'data-bg-from-db': 'true' })}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container>
        <Row className="g-4 g-lg-5 align-items-center">
          <Col lg={7}>
            <div className="contact-form-map ratio ratio-4x3 rounded-4 overflow-hidden shadow">
              <iframe
                title="South Crete Tours office"
                src={mapEmbedUrl}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Col>
          <Col lg={5}>
            <Card className="contact-form-card p-4">
              <CardHeader className="bg-transparent border-0 px-0 pb-2">
                <h3 className="mb-2 fs-4">{titleText}</h3>
              </CardHeader>
              <CardBody className="px-0 pt-0 pb-0">
                {status === 'success' ? (
                  <InquiryFormExtras
                    status={status}
                    confirmation={confirmation}
                    onReset={resetStatus}
                  />
                ) : (
                  <form onSubmit={onSubmit} className="row g-3" noValidate>
                    <TextFormInput
                      name="name"
                      label="Your name *"
                      containerClass="col-md-6"
                      control={control}
                      rules={{ required: true }}
                    />
                    <TextFormInput
                      name="email"
                      label="Email address *"
                      containerClass="col-md-6"
                      control={control}
                      rules={{ required: true }}
                    />
                    <TextFormInput
                      name="mobileNo"
                      label="Phone number *"
                      containerClass="col-md-6"
                      control={control}
                      rules={{ required: true }}
                    />
                    <CountryFormInput
                      name="country"
                      label="Country"
                      containerClass="col-md-6"
                      control={control}
                    />
                    <TextAreaFormInput
                      name="message"
                      label="How can we help? *"
                      containerClass="col-12"
                      rows={4}
                      control={control}
                      rules={{ required: true }}
                    />
                    <CheckFormInput
                      id="contact-newsletter-opt-in"
                      name="newsletterOptIn"
                      type="checkbox"
                      label="Keep me updated with news and offers."
                      containerClass="col-12 form-check ms-2"
                      control={control}
                    />
                    <Col xs={12}>
                      <InquiryFormExtras
                        honeypotId="contact-website-field"
                        websiteField={websiteField}
                        setWebsiteField={setWebsiteField}
                        turnstileRef={turnstile.containerRef}
                        showTurnstileConfigWarning={showTurnstileConfigWarning}
                        error={error}
                        status={status}
                      />
                    </Col>
                    <Col xs={12}>
                      <Button variant="dark" className="mb-0" type="submit" disabled={submitting}>
                        {submitting ? 'Sending…' : 'Send Message'}
                      </Button>
                    </Col>
                  </form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactForm;

